module.exports = __webpack_public_path__ + "img/组 1106.3d55948b.png";